export const getDateString = (date, separator, omitYear, omitDay) => {
    if (typeof date === "string") return date;
    if (!separator) separator = '-'
    var month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
    var day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate()
    if (omitYear) return month + separator + day;
    if (omitDay) return date.getFullYear() + separator + month;
    return (date.getFullYear() + separator + month + separator + day)
}

export const getDateTimeString = (date, separator) => {
    if (typeof date === "string") return date;
    if (!separator) separator = '-'
    var month = getTwoDigits(date.getMonth() + 1)
    var day = getTwoDigits(date.getDate())
    return (
        date.getFullYear() +
        separator +
        month +
        separator +
        day + " "
        + getTwoDigits(date.getHours()) + ":" +
        getTwoDigits(date.getMinutes()) + ":" +
        getTwoDigits(date.getSeconds()))
}

function getTwoDigits(dateElement) {
    return dateElement > 9 ? dateElement.toString() : '0' + dateElement
}

export function getDateFromString(date) {
    if (!date) return
    const dateParts = date.split('-')
    if (dateParts.length < 3) return date;

    const timePart = date.split(' ')[1]
    var hours = 0;
    var minutes = 0;

    if (timePart) {

        const timeParts = timePart.split(":")
        hours = parseInt(timeParts[0].trim())
        minutes = parseInt(timeParts[1].trim())
    }
    return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2].split(' ')[0]), hours, minutes)
}

export function getLangBasedStringDate(date) {
    var dateStr = getDateString(date)
    if (Storage.getLang() != "ko") return dateStr
    dateStr = dateStr.substring(2, dateStr.length)
    dateStr = dateStr.replace("-", "년 ")
    dateStr = dateStr.replace("-", "월 ")

    return dateStr.concat("일")
}

export function compareDates(date1, date2, compareDays = true) {
    if (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()) return 0;

    if (date1.getFullYear() < date2.getFullYear()) return -1;
    if (date1.getFullYear() > date2.getFullYear()) return 1;

    if (date1.getMonth() < date2.getMonth()) return -1;
    if (date1.getMonth() > date2.getMonth()) return 1;

    if (compareDays) {
        if (date1.getDate() < date2.getDate()) return -1;
        if (date1.getDate() > date2.getDate()) return 1;
    }
    return 0
}

export function addDaysToDate(date, addition) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + addition)
}
export function addMonthsToDate(date, addition) {
    return new Date(date.getFullYear(), date.getMonth() + addition, 1)
}
export function daysInMonth(month, year) {
    return new Date(year, month + 1, 0).getDate();
}

export function getDaysDifference(date1, date2) {
    date1 = new Date(date1)
    date2 = new Date(date2)
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.round(Math.abs(new Date(date2) - new Date(date1)) / msPerDay);
}